// import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { CSS2DObject } from '../renderer/CSS2DRenderer';
class Dom extends CSS2DObject {
    // private dom:any;
    props;
    center;
    innerDom;
    constructor(data) {
        const { renderProps, onLoad, position, zIndex = 0, visible = true } = data;
        const { dom } = renderProps;
        if (dom && dom.style) {
            dom.style.zIndex = '' + zIndex;
        }
        super(dom);
        this.props = data;
        this.visible = visible;
        this.position.set(position.x, position.y, position.z);
        this.name = this.uuid;
        this.center = this.position;
        // this.update(data);
        if (onLoad && typeof onLoad === 'function') {
            onLoad(this);
        }
    }
    /**
     * DOM 更新材质回引起位置偏移问题，考虑重写css2dRender类
     */
    // update(data:DomClass) {
    //   const { visible = true, renderProps, position, zIndex = 0 } = data;
    //   const { dom } = renderProps;
    //   this.visible = visible;
    //   const x = position.x;
    //   const y = position.y;
    //   this.position.set(x, y, zIndex);
    //   this.center = this.position;
    //   // const parent = this.parent;
    //   if (dom !== this.props.renderProps.dom) {
    //     // this.dispose();
    //     // console.log(parent);
    //     const dom = document.createElement('div');
    //     dom.innerHTML = '23232';
    //     console.log(this);
    //     this.element = dom;
    //     // parent?.add(this);
    //   }
    //   this.props = data;
    // }
    onMouseEnter() {
        // console.log(213123123);
    }
    dispose() {
        this.parent?.remove(this);
        this.clear();
    }
}
export default Dom;
